import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ApiConfig } from '../../../utility/ApiConfig';
import { FormArray, FormControl, FormControlDirective, FormGroup, Validators } from '@angular/forms';
declare function setDatatableSearch(): any;

@Component({
  selector: 'app-approval-loan',
  templateUrl: './approval-loan.component.html',
  styleUrls: ['./approval-loan.component.sass']
})
export class ApprovalLoanComponent implements OnInit {

  constructor(
    private ApiConfig: ApiConfig,
    private router: Router,
    private http: HttpClient
  ) { }

  dtOptions: any = {};
  httpOptions: any = {headers: new HttpHeaders({ 'Content-Type': 'application/json', 'token': this.ApiConfig.get("user-data").token })};
  responseApi: any;

  ngOnInit(): void {
    this.dtOptions = {
      dom: 'rtpl',
      ajax: {
          url: this.ApiConfig.API_URL + "/loan-pending",
          headers: { 'token': this.ApiConfig.USER_DATA.token },
          data: function (data) {
              setDatatableSearch();
              return data;
          }
      },
      columns: [
          {title: 'ID',data:'id'},
          {title: 'No. CIF',data:'cif_id'},
          {title: 'Nama',data:'full_name'},
          {title: 'Status',data:'status_approval'},
          {title: 'Submitted By',data:'username'},
          {
            data: null, title: 'Action', defaultContent: "",
            render: function (data, type, row) {
                return '<button class="btn btn-gray view-btn"></button>';
            }
          }
      ],
      rowCallback: (row: Node, data: any[] | Object, index: number) => {
          const self = this;
          $('.view-btn', row).unbind('click');
          $('.view-btn', row).bind('click', () => {
            self.approval(data);
          });
          return row;
      } 
    };
  }//ngOnInit

  approval(data){
    this.router.navigate(['/admin/approve-menu-loan/' + data.id ]);
  }
}
